/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SemUsePatternRequest { 
    relativeUrl: string;
    regionId: number;
    city?: string;
    pageNum?: number;
    patternType: SemUsePatternRequest.PatternTypeEnum;
    entityId?: number;
    slug?: string;
    filterId?: number;
    filterValue?: number;
    filterValues?: Array<number>;
}
export namespace SemUsePatternRequest {
    export type PatternTypeEnum = 'category' | 'item' | 'filter' | 'action' | 'brand' | 'recipe' | 'collection' | 'landing' | 'article' | 'similar_products' | 'search' | 'default';
    export const PatternTypeEnum = {
        Category: 'category' as PatternTypeEnum,
        Item: 'item' as PatternTypeEnum,
        Filter: 'filter' as PatternTypeEnum,
        Action: 'action' as PatternTypeEnum,
        Brand: 'brand' as PatternTypeEnum,
        Recipe: 'recipe' as PatternTypeEnum,
        Collection: 'collection' as PatternTypeEnum,
        Landing: 'landing' as PatternTypeEnum,
        Article: 'article' as PatternTypeEnum,
        SimilarProducts: 'similar_products' as PatternTypeEnum,
        Search: 'search' as PatternTypeEnum,
        Default: 'default' as PatternTypeEnum
    };
}


